import $ from 'jquery';

import Accordion from '../Accordion';

export default class NavMobileSubMenus {
  constructor($el) {
    this.$el = $el;

    this.Accordion = new Accordion(this.$el, {
      activeClass: 'visible',
      content: '[data-accordion-content]',
    });

    // Sub menu selectors
    this.activeMenuClass = 'navmenu-link-parent-active';
    this.activeMenu = `.${this.activeMenuClass}`;
    this.navTrigger = '[data-navmenu-trigger]';
    this.subMenu = '[data-navmenu-submenu]';

    this._bindEvents();
  }

  unload() {
    this.$el.off('.mobile-nav');

    delete this.Accordion;
  }

  closeSubMenus($current) {
    $current.find(this.activeMenu).each((index, el) => {
      this._closeSubmenu($(el));
    });
  }

  closeAllSubmenus() {
    this.Accordion.closeOpen();
  }

  _bindEvents() {
    // Prevent focus state from applying on mouse click
    this.$el.on('mousedown.mobile-nav', '.navmenu-link', (event) => {
      event.preventDefault();
    });

    this.$el.on('click.mobile-nav', `${this.navTrigger} > .navmenu-link-parent`, (event) => {
      event.preventDefault();
      this._toggleSubmenu(event);
    });
  }

  _selectSubMenu($target) {
    return $target.next(this.subMenu);
  }

  _toggleSubmenu(event) {
    const $target = $(event.currentTarget);

    if ($target.hasClass(this.activeMenuClass)) {
      this._closeSubmenu($target);
    } else {
      this._openSubmenu($target);
    }
  }

  _openSubmenu($target) {
    const $menu = this._selectSubMenu($target);

    $target
      .addClass(this.activeMenuClass)
      .attr('aria-expanded', true);
    this.Accordion.toggle($menu);
  }

  _closeSubmenu($target) {
    const $menu = this._selectSubMenu($target);

    $target
      .removeClass(this.activeMenuClass)
      .attr('aria-expanded', false);
    this.Accordion.toggle($menu);
    this.closeSubMenus($menu);
  }
}
